const checkIsDefined = (maybeT) => maybeT !== null && maybeT !== void 0;
export {
  checkIsDefined
};
